import {Card} from "@shopify/polaris"
import ProductCard from "@pages/dashboard/components/productCard";
import { useEffect, useState } from "react";
import axios from "@plugins/axios";

export default function OurApps() {
  const [loading, setLoading] = useState(false)
  const [products, setProducts] = useState([])

  useEffect(() => {
    axios.get(`/api/strapi/fox-products`).then(response => {
      if (response && response?.payload) setProducts(response?.payload?.filter(i => i.type === 'app'))
    }).catch(err => console.log(err))
    .finally(() => setLoading(false))
  }, [])

	return (
		<Card
			title={'Our Shopify apps'}
      sectioned
		>
			<div className={'flex'} style={{gap: '3rem'}}>
        {products.map(product => {
          return (
            <ProductCard
              key={product.id}
              title={product.title}
              url={product.link}
              learn_more={product.learn_more}
              img={product.image}
              content={product.content}
            />
          )
        })}
			</div>
		</Card>
	)
}
